import { render, staticRenderFns } from "./Trials.vue?vue&type=template&id=2726ca93&scoped=true"
import script from "./Trials.vue?vue&type=script&lang=js"
export * from "./Trials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726ca93",
  null
  
)

export default component.exports